import React from "react";
import { ClipLoader } from "react-spinners";
import styled from "styled-components";
import { CurrentProfile } from "@domain/currentProfile/currentProfile";
import { Group } from "@domain/group/group";
import { useGroupMembers } from "@domain/user/hooks";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { AdministratorList } from "@ui/components/group/community/administrastorList";
import { stack } from "@ui/components/layout";
import { mobile } from "@ui/styles/utils";

interface ShareroomAdminListProps extends React.HTMLAttributes<HTMLDivElement> {
	shareroom: Group;
	profile: CurrentProfile | null;
}

export const ShareroomAdminList: React.FC<ShareroomAdminListProps> = ({ shareroom, profile, ...htmlProps }) => {
	const { result: teachers, totalElements, loading } = useGroupMembers(shareroom.id, "ADMINISTRATOR");

	return (
		<Container {...htmlProps}>
			{loading ? (
				<ClipLoader />
			) : (
				<AdministratorList
					members={teachers}
					shareroom={shareroom}
					profile={profile}
					limitReached={(totalElements as number) >= 4}
				/>
			)}
		</Container>
	);
};

const Container = styled(RoundedBlock)`
	padding: 30px 40px;
	${stack(30)}
	width:100%;
	@media ${mobile} {
		padding: 20px;
	}
`;
